import { formatNumber } from "@tosize/ui";
import { useIntl } from "react-intl";
import { useCanvasStore } from "../../../hooks/useCanvasStore";
import { useDebug } from "../debug";

export function useDimensions() {
	const { debugEnabled } = useDebug();
	const { dimensionUnit } = useCanvasStore();
	const intl = useIntl();

	function format(value: number) {
		if (debugEnabled) {
			return formatNumber({
				lang: intl.locale,
				value: Number(value.toFixed(1)),
				unit: "millimeter",
				digits: { min: 0, max: 0 },
			});
		}

		if (dimensionUnit === "mm") {
			return formatNumber({
				lang: intl.locale,
				value: Math.round(value),
				unit: "millimeter",
				digits: { min: 0, max: 0 },
			});
		}

		return formatNumber({
			lang: intl.locale,
			value: Math.round(value / 10),
			unit: "centimeter",
			digits: { min: 0, max: 0 },
		});
	}

	return { format } as const;
}
